import React from 'react';

import Add from './Add';
import ListVitalSigns from './List';

export default function Index() {
  return (
    <>
      <ListVitalSigns />
      <Add />
    </>
  );
}
